export const LOAD_B2B_PERMISSIONS_START = "LOAD_B2B_PERMISSIONS_START";
export const LOAD_B2B_PERMISSIONS_SUCCESS = "LOAD_B2B_PERMISSIONS_SUCCESS";
export const LOAD_B2B_PERMISSIONS_ERROR = "LOAD_B2B_PERMISSIONS_ERROR";
